// extracted by mini-css-extract-plugin
module.exports = {"root":"LinkButton_root__XUKic","icon":"LinkButton_icon__Rt0XL","label":"LinkButton_label__ejMgO"};